(function () {
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || '${{amount}}');
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    }).format(cents / 100);
  }

  function getPicker(sectionId) {
    return document.querySelector(`#variant-selects-${sectionId}.custom-variant-picker`);
  }

  function getRoleValue(picker, role) {
    const fieldset = picker.querySelector(`fieldset[data-option-role="${role}"]`);
    const input = fieldset?.querySelector('input[type="radio"]:checked');
    return input?.value || null;
  }

  function getSelectedValues(picker) {
    const values = {};
    picker.querySelectorAll('fieldset[data-option-name]').forEach((fieldset) => {
      const optionName = fieldset.dataset.optionName;
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (optionName && checked) {
        values[optionName] = checked.value;
      }
    });
    return values;
  }

  function getVariants(picker) {
    const node = picker.querySelector('[data-product-variants]');
    return node ? JSON.parse(node.textContent) : [];
  }

  function getOptions(picker) {
    const node = picker.querySelector('[data-product-options]');
    return node ? JSON.parse(node.textContent) : [];
  }

  function getNamesCount(value) {
    const match = String(value).match(/\d+/);
    return match ? parseInt(match[0], 10) : 1;
  }

  function updateSummary(picker) {
    const summaryEl = picker.querySelector('[data-variant-summary]');
    if (!summaryEl) return;

    const color = getRoleValue(picker, 'color');
    const names = getRoleValue(picker, 'names');
    const size = getRoleValue(picker, 'size');
    const segments = [];

    if (color) {
      segments.push(`<strong>${escapeHtml(color)}</strong>`);
    }

    if (names) {
      const count = getNamesCount(names);
      const nameLabel = count === 1 ? 'Name' : 'Names';
      segments.push(`<strong>${escapeHtml(names)}</strong> ${nameLabel}`);
    }

    if (size) {
      segments.push(`<strong>${escapeHtml(size)}</strong>`);
    }

    summaryEl.innerHTML = segments.length ? `Selected: ${segments.join(' · ')}` : '';
  }

  function updateNamesAddon(picker) {
    const addonEl = picker.querySelector('[data-names-addon]');
    if (!addonEl) return;

    const namesFieldset = picker.querySelector('fieldset[data-option-role="names"]');
    const namesOption = namesFieldset?.dataset.optionName;
    if (!namesOption) {
      addonEl.textContent = '';
      return;
    }

    const variants = getVariants(picker);
    const options = getOptions(picker);
    const selected = getSelectedValues(picker);
    const namesValue = selected[namesOption];

    if (!namesValue) {
      addonEl.textContent = '';
      return;
    }

    const currentVariant = variants.find((variant) =>
      options.every((option, index) => variant.options[index] === selected[option])
    );

    const namesIndex = options.indexOf(namesOption);
    const baselineVariant =
      variants.find((variant) => {
        if (getNamesCount(variant.options[namesIndex]) !== 1) return false;
        return options.every((option, index) => {
          if (index === namesIndex) return true;
          return variant.options[index] === selected[option];
        });
      }) || variants.find((variant) => getNamesCount(variant.options[namesIndex]) === 1);

    const template =
      picker.dataset.namesAddonTemplate || '+{amount} for {count} name selected';
    const count = getNamesCount(namesValue);
    const diff = currentVariant && baselineVariant ? currentVariant.price - baselineVariant.price : 0;
    const amount = formatMoney(Math.max(diff, 0), picker.dataset.moneyFormat);

    addonEl.textContent = template.replace('{amount}', amount).replace('{count}', count);
  }

  function syncCustomPrice(sectionId) {
    const source = document.getElementById(`price-${sectionId}`);
    const target = document.querySelector(`[data-custom-variant-price="${sectionId}"]`);
    if (source && target) {
      target.innerHTML = source.innerHTML;
    }
  }

  function refreshPicker(picker) {
    if (!picker) return;
    updateSummary(picker);
    updateNamesAddon(picker);
    syncCustomPrice(picker.dataset.section);
  }

  function initPicker(picker) {
    if (!picker || picker.dataset.customPickerInit === 'true') return;
    picker.dataset.customPickerInit = 'true';
    refreshPicker(picker);

    picker.addEventListener('change', () => {
      window.requestAnimationFrame(() => refreshPicker(picker));
    });
  }

  function initAll() {
    document.querySelectorAll('.custom-variant-picker').forEach(initPicker);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('product-info:loaded', () => {
    window.requestAnimationFrame(initAll);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      if (!sectionId || !getPicker(sectionId)) return;

      document.querySelectorAll('.custom-variant-picker').forEach((picker) => {
        picker.dataset.customPickerInit = 'false';
        initPicker(picker);
      });
    });
  }
})();
